import { type ChangeEvent, type FormEvent, useState } from 'react';
import { api } from '../../../api/client';
import styles from './AnnouncementForm.module.css';

interface AnnouncementFormProps {
  onClose: () => void;
  onSuccess: () => void;
}

export default function AnnouncementForm({ onClose, onSuccess }: AnnouncementFormProps) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [priority, setPriority] = useState('NORMAL');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !content.trim()) return;
    setLoading(true);
    setError('');

    try {
      await api.post('/api/communication/announcements', { title, content, priority });
      onSuccess();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Nuevo Anuncio</h2>
          <button onClick={onClose} className={styles.closeBtn}>
            &times;
          </button>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label>Título</label>
            <input
              value={title}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)}
              required
              placeholder="Título del anuncio"
            />
          </div>
          <div className={styles.field}>
            <label>Prioridad</label>
            <select
              value={priority}
              onChange={(e: ChangeEvent<HTMLSelectElement>) => setPriority(e.target.value)}
            >
              <option value="URGENT">Urgente</option>
              <option value="HIGH">Alta</option>
              <option value="NORMAL">Normal</option>
              <option value="LOW">Baja</option>
            </select>
          </div>
          <div className={styles.field}>
            <label>Contenido</label>
            <textarea
              value={content}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setContent(e.target.value)}
              required
              rows={5}
              placeholder="Escribe el contenido del anuncio..."
            />
          </div>

          <div className={styles.footer}>
            <button type="button" onClick={onClose} className={styles.cancelBtn}>
              Cancelar
            </button>
            <button type="submit" disabled={loading} className={styles.submitBtn}>
              {loading ? 'Publicando...' : 'Publicar Anuncio'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
